import React from 'react';
import pauseLaptopChatSrc from '../../assets/images/slide/pause-laptop-chat.png';
import pauseChaptersLaptopSrc from '../../assets/images/slide/pause-chapters-laptop.png';
import pausePhoneQuestionsSrc from '../../assets/images/slide/pause-phone-questions.png';
import { EMAIL_SLIDE, PAUSE_SLIDE, PLAN_GRAPH_SLIDE, PLAN_LOADER_SLIDE, PRODUCT_SLIDE, PROFILE_SLIDE, QUESTION_ANSWER_SLIDE_COMPONENT, QUESTION_SCALE_SLIDE_COMPONENT, RESULT_SLIDE, START_SLIDE } from '../quiz-component-types';

const SCALE_ANSWERS = [
    {
        text: 'Strongly disagree',
        icon: 'thumbs-down',
        id: 1,
        score: 1
    },
    {
        text: 'Disagree',
        icon: 'thumbs-down',
        id: 2,
        score: 2
    },
    {
        text: 'Neutral',
        icon: 'woman-shrugging',
        id: 3,
        score: 3
    },
    {
        text: 'Agree',
        icon: 'thumbs-up',
        id: 4,
        score: 4
    },
    {
        text: 'Strongly agree',
        icon: 'thumbs-up',
        id: 5,
        score: 5
    }
];

const PLAN_LOADER_REVIEWS = [
    {
        id: 1,
        title: 'As easy as talking to an old friend',
        quote: 'I’m not big on technology, but Boundly made it feel like chatting with an old friend.',
        name: 'Paul',
        date: 'September',
        initial: 'P',
        avatarColor: '#944343'
    },
    {
        id: 2,
        title: 'Mom’s stories we never knew',
        quote: 'My mom remembered stories from her whole life — the best gift we’ve ever given her.',
        name: 'Natalie',
        date: 'September',
        initial: 'N',
        avatarColor: '#5C8C5E'
    },
    {
        id: 3,
        title: 'A bridge to my kids, one story at a time',
        quote: 'My kids live abroad, and through my stories, I hope we’ll feel more connected.',
        name: 'Ruby',
        date: 'September',
        initial: 'R',
        avatarColor: '#3A6194'
    }
];

const QUIZ_SLIDES_V37 = [
    {
        id: 900,
        component: START_SLIDE,
        isNotIndexing: true
    },
    {
        id: 9001,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v20'
        }
    },
    {
        id: 9010,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'About you',
            question: 'How old are you?',
            answers: [
                {
                    text: 'Under 35',
                    id: 1
                },
                {
                    text: '35–44',
                    id: 2
                },
                {
                    text: '45–54',
                    id: 3
                },
                {
                    text: '55–64',
                    id: 4
                },
                {
                    text: '65+',
                    id: 5
                }
            ]
        }
    },
    {
        id: 9011,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'Your photos',
            statement: '“I have old photos, and I can’t remember the stories behind some of them.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9029,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'Your photos',
            statement: '“Names and places from my younger years are starting to slip away.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9030,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your photos',
            question: 'Where are most of your old photos now?',
            answers: [
                {
                    text: 'In albums',
                    icon: 'books',
                    id: 1
                },
                {
                    text: 'In boxes or drawers',
                    icon: 'package',
                    id: 2
                },
                {
                    text: 'On my phone or computer',
                    icon: 'mobile-phone',
                    id: 3
                },
                {
                    text: 'With other family members',
                    icon: 'family',
                    id: 4
                },
                {
                    text: 'I don’t have many',
                    icon: 'woman-shrugging',
                    id: 5
                }
            ]
        }
    },
    {
        id: 9031,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your photos',
            question: 'Is there a photo you love because of the story behind it, not the picture itself?',
            answers: [
                {
                    text: 'Yes, more than one',
                    icon: 'yellow-heart',
                    id: 1
                },
                {
                    text: 'Maybe one',
                    icon: 'thinking-face',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'person-gesturing-no',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9008,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v21'
        }
    },
    {
        id: 9032,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'Your stories',
            statement: '“My life is full of stories worth telling.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9033,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'Your stories',
            statement: '“There are stories from my life I’ve never told anyone.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9034,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your stories',
            question: 'Is it easier for you to answer a question than to start from scratch?',
            answers: [
                {
                    text: 'Much easier',
                    icon: 'raising-hands',
                    id: 1
                },
                {
                    text: 'Depends',
                    icon: 'thinking-face',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'person-gesturing-no',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9009,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v22',
            imageSrc: pauseLaptopChatSrc,
            title: 'You don’t need a big story to start',
            description: (
                <>
                    <p>The kitchen you grew up in. Your first paycheck. The street at dusk.</p>
                    <p>Boundly starts with the small things, <strong>one easy question at a time.</strong> Week by week, they become your digital book.</p>
                </>
            )
        }
    },
    {
        id: 9035,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'How you tell it',
            statement: '“I’m better at telling stories than writing them.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9036,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'How you tell it',
            statement: '“I never know where to start with my own story.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9037,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'How you tell it',
            question: 'Have you ever tried to write your memories down?',
            answers: [
                {
                    text: 'Yes, and I kept going',
                    icon: 'book',
                    id: 1
                },
                {
                    text: 'Yes, but I stopped',
                    icon: 'pencil',
                    id: 2
                },
                {
                    text: 'I’ve thought about it',
                    icon: 'thought-ballon',
                    id: 3
                },
                {
                    text: 'Not yet',
                    icon: 'person-gesturing-no',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9038,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'How you tell it',
            question: 'Is talking easier for you than typing?',
            answers: [
                {
                    text: 'Much easier',
                    icon: 'studio-microphone',
                    id: 1
                },
                {
                    text: 'About the same',
                    icon: 'thinking-face',
                    id: 2
                },
                {
                    text: 'Typing is easier',
                    icon: 'keyboard',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9039,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v23'
        }
    },
    {
        id: 9040,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'Your family',
            statement: '“I know family stories that no one else remembers.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9041,
        component: QUESTION_SCALE_SLIDE_COMPONENT,
        props: {
            category: 'Your family',
            statement: '“I wish I had asked my parents or grandparents more about their lives.”',
            question: 'Does this feel true for you?',
            answers: SCALE_ANSWERS
        }
    },
    {
        id: 9042,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your family',
            question: 'Who would you share your first story with?',
            answers: [
                {
                    text: 'My kids',
                    icon: 'family',
                    id: 1
                },
                {
                    text: 'A partner or friend',
                    icon: 'revolving-hearts',
                    id: 2
                },
                {
                    text: 'My whole family',
                    icon: 'house-with-garden',
                    id: 3
                },
                {
                    text: 'No one yet, it’s for me',
                    icon: 'slightly-smiling-face',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9043,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your family',
            question: 'Would you like your stories and photos kept together, for whoever you choose?',
            answers: [
                {
                    text: 'Yes, I’d love that',
                    icon: 'raising-hands',
                    id: 1
                },
                {
                    text: 'Maybe',
                    icon: 'thinking-face',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'person-gesturing-no',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9044,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v24'
        }
    },
    {
        id: 9045,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v22',
            imageSrc: pauseChaptersLaptopSrc,
            title: 'Almost there: your first chapter',
            description: 'Three quick questions about your early years, then we’ll build your plan.'
        }
    },
    {
        id: 9046,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your first chapter',
            question: 'Where did you grow up?',
            answers: [
                {
                    text: 'In a city',
                    icon: 'cityscape',
                    id: 1
                },
                {
                    text: 'In a small town',
                    icon: 'house-with-garden',
                    id: 2
                },
                {
                    text: 'In the country',
                    icon: 'sheaf-of-rice',
                    id: 3
                },
                {
                    text: 'We moved around a lot',
                    icon: 'delivery-truck',
                    id: 4
                },
                {
                    text: 'Somewhere else',
                    icon: 'sparkles',
                    id: 5
                }
            ]
        }
    },
    {
        id: 9047,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your first chapter',
            question: 'Was there a pet in your childhood home?',
            answers: [
                {
                    text: 'Yes, a dog',
                    icon: 'dog-face',
                    id: 1
                },
                {
                    text: 'Yes, a cat',
                    icon: 'cat-face',
                    id: 2
                },
                {
                    text: 'Another pet',
                    icon: 'rabbit-face',
                    id: 3
                },
                {
                    text: 'No pets',
                    icon: 'prohibited',
                    id: 4
                },
                {
                    text: 'I don’t remember',
                    icon: 'woman-shrugging',
                    id: 5
                }
            ]
        }
    },
    {
        id: 9048,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your first chapter',
            question: 'Who did you spend the most time with as a kid?',
            answers: [
                {
                    text: 'Mom or Dad',
                    icon: 'family',
                    id: 1
                },
                {
                    text: 'Grandparents',
                    icon: 'old-woman',
                    id: 2
                },
                {
                    text: 'Brothers or sisters',
                    icon: 'child',
                    id: 3
                },
                {
                    text: 'Neighborhood friends',
                    icon: 'houses',
                    id: 4
                },
                {
                    text: 'Someone else',
                    icon: 'sparkles',
                    id: 5
                }
            ]
        }
    },
    {
        id: 9049,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v22',
            imageSrc: pausePhoneQuestionsSrc,
            title: 'Every question is written for you.',
            description: 'Not a list. A conversation that starts with your small town, your dog, your grandparents.'
        }
    },
    {
        id: 9050,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your plan',
            question: 'How often would you like to tell a story?',
            answers: [
                {
                    text: 'A few times a week',
                    icon: 'calendar',
                    id: 1
                },
                {
                    text: 'Once a week',
                    icon: 'spiral-calendar',
                    id: 2
                },
                {
                    text: 'Whenever I feel like it',
                    icon: 'herb',
                    id: 3
                },
                {
                    text: 'Not sure yet',
                    icon: 'woman-shrugging',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9051,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your plan',
            question: 'Do you want to include photos in your digital book?',
            answers: [
                {
                    text: 'Yes, definitely',
                    icon: 'camera-with-flash',
                    id: 1
                },
                {
                    text: 'Not sure yet',
                    icon: 'thinking-face',
                    id: 2
                }
            ]
        }
    },
    {
        id: 9052,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your plan',
            question: 'Picture this: 3 months from now, your first chapters are written, with your photos. How does that feel?',
            answers: [
                {
                    text: 'I’d be so proud',
                    icon: 'face-holding-back-tears',
                    id: 1
                },
                {
                    text: 'My family would love it',
                    icon: 'family',
                    id: 2
                },
                {
                    text: 'I can’t wait to start',
                    icon: 'sparkles',
                    id: 3
                },
                {
                    text: 'Not sure yet',
                    icon: 'woman-shrugging',
                    id: 4
                }
            ]
        }
    },
    {
        id: 944,
        component: PLAN_LOADER_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        props: {
            heading: 'Putting your answers together',
            steps: ['Reading your answers', 'Choosing where to start', 'Putting your plan together'],
            reviews: PLAN_LOADER_REVIEWS
        }
    },
    {
        id: 945,
        component: EMAIL_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true
    },
    {
        id: 9053,
        component: RESULT_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 9054,
        component: PRODUCT_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v16'
        }
    },
    {
        id: 9006,
        component: PROFILE_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 946,
        component: PLAN_GRAPH_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 9055,
        component: PRODUCT_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v17'
        }
    }
];

export {
    QUIZ_SLIDES_V37
};
